import { withStyles } from '@material-ui/core';
import React from 'react';
import appConstant from '../../../../../../appConstants';
import { TimeRangeEditor } from '@dataGrid/components/cellEditors';
const styles = (theme) => ({
  error: {
    color: theme.ErrorMessageColor,
    fontSize: theme.textFontSize
  },
  labelProps: {
    fontSize: theme.textFontSize,
    color: theme.iconColor,
    marginTop: -20
  },
  labelShrink: {
    zIndex: -100,
    fontSize: 0,
  }
});

const TimePeriod = React.memo((props) => {
  const { selectedTimePeriod, onChangeTimePeriod, classes } = props;
  const updateTime = (time) => {
    if (time !== appConstant.INVALID_TIME_RANGE && props.time !== time) {
      onChangeTimePeriod(time);
    }
  };
  return (
    <TimeRangeEditor
      DATETYPE={appConstant.DATETYPES.TIME}
      isTimeInterval
      value={selectedTimePeriod}
      onChange={updateTime}
      componentSpecificProps={{
        startLabel: 'Start Time',
        endLabel: 'End Time',
        roundInputBorder: true,
        containerLabel: 'Time Period'
      }}
      InputLabelProps={{
        classes: {
          root: classes.labelProps,
          shrink: classes.labelShrink
        }
      }}
    />
  );
});
export default withStyles(styles)(TimePeriod);
